import React from 'react';
import {Card, CardContent} from "@material-ui/core";
import {Elements, Objects} from "components"


export default class WorkOrderView extends React.Component {
	handleContractChanged = () => {
		const header = this.props.refTransaction?.current;
		if (header && typeof header.reloadContractHeader === 'function') {
			void header.reloadContractHeader();
		}
	};

	render() {
		return <>
			<Card>
				<CardContent>
					<div className={'row'}>
						<div className={'col-lg-7'}>
							<Objects.WorkOrder
								ref={this.props.refTransaction}
								id={this.props.id}
								history={this.props.history}
								locations={this.props.locations}
								setRemaining={this.props.setRemaining}
							/>
						</div>
						<div className={'col-lg-5'}>
							<Elements.WorkOrderItems
								ref={this.props.refTransactionItems}
								work_order={this.props.id}
								onContractChanged={this.handleContractChanged}
								history={this.props.history}
							/>
						</div>
					</div>
				</CardContent>
			</Card>

		</>

	}
}
